<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1 style="font-family:Calisto MT;font-size:20pt">About the Author</h1>
<p>Lynn Mathai grew up in Queens, New York. He faced many disabilities while growing up and, although he worked through some, he still faces many of them today. Lynn enjoys writing stories for his nephews and niece. He is an avid reader and has always enjoyed fantasy, science fiction, and adventure books.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?74d23e44